<template>
    <tariff-history :profileTariff="tariff" :loading="isFetching" @sort="sorting" :sort="sort" :history="sortedHistory" @tariff-closed="fetchProducts" :products="products"/>
</template>
<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import TariffHistory from './TariffHistory.vue';

    export default {
        name: 'tariff-history-container',
        components: {
            TariffHistory,
        },
        data() {
            return {
                isFetching: true,
            }
        },
        methods: {
            ...mapActions('tariffHistory', ['fetchHistory', 'sorting']),
            ...mapActions('profileTariff', ['fetchProfileTariff']),
            ...mapActions('request', ['fetchAvailableProducts', 'fetchRequestFields']),

            fetchProducts() {
                this.isFetching = true;
                return this.fetchAvailableProducts().then(() => {
                    this.isFetching = false;
                });
            }
        },
        created() {
            this.fetchProfileTariff();

            this.fetchHistory()
                .then((res) => {
                    this.isFetching = false;
                })
                .catch((res) => {
                    this.isFetching = false;
                });
        },
        computed: {
            ...mapGetters('tariffHistory', ['sortedHistory', 'sort']),
            ...mapGetters('profileTariff', ['tariff']),
            ...mapGetters('request', ['products']),
        }
    }
</script>



// WEBPACK FOOTER //
// TariffHistoryContainer.vue?484c46d8